import { defineComponent } from 'vue';
import utils from '@/public/utils/index';
import app from '@/widget/app';
import { hostPath } from '@/public/utils/basePath';
export default defineComponent({
    props: {
        size: {
            type: String,
            default: 'normal'
        },
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        toDetail(item) {
            if (utils.isApp()) {
                app.postMessage({
                    type: 'meeting_detail',
                    id: item.meetingId
                });
            }
            else {
                window.open(`${hostPath}/study/detail?id=${item.meetingId}`);
            }
        }
    }
});
